<template>
    <v-dialog persistent v-model="editDialog" max-width="500">
        <template v-slot:activator="{ on, attrs }">
            <template v-if="$scopedSlots.activator">
                <slot name="activator" :on="on" :attrs="attrs" :open="openDialog" :disabled="selected.length !== 1"></slot>
            </template>
            <v-btn v-else v-bind="attrs" v-on="on" :disabled="selected.length != 1" text block color="secondary" class="justify-start">
                <v-icon left>mdi-table-edit</v-icon>
                edit description
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="flex-nowrap align-start">
                <div class="d-flex align-center secondary--text">
                    <span>{{ objectType }} edit description</span>
                </div>

                <v-spacer></v-spacer>
                <v-btn @click="editDialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="mt-1">
                <span class="font-weight-bold">Old {{ objectType }} description:</span>
                <p>{{ oldName }}</p>
                <span class="font-weight-bold">New {{ objectType }} description:</span>
                <v-text-field v-model="newObjectName" outlined>
                    <template v-slot:label>Provide a new {{ objectType }} description</template>
                </v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn :loading="editing" text color="error" @click="edit">confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { enumsData } from '@/mixins/enums'
import { createBackendErrorHandler } from '@/utils/errorMessages'
import * as lifecycleErrors from '@/modules/snapshot/errors/lifecycle'
import * as permissionsErrors from '@/utils/errors/permissions'
import * as snapshotErrors from '@/modules/snapshot/errors/snapshots'
import * as tablesErrors from '@/modules/snapshot/errors/tables'

const { getBackendErrorMessage } = createBackendErrorHandler(lifecycleErrors, permissionsErrors, snapshotErrors, tablesErrors)

export default {
    name: 'EditDescriptionButton',
    mixins: [enumsData],
    data: function () {
        return {
            editDialog: false,
            newObjectName: '',
            successMessage: '',
            editing: false
        }
    },
    props: {
        selected: Array,
        objectType: String,
        dispatchFunction: Function
    },
    computed: {
        oldName: function () {
            if (this.selected.length && this.selected[0].description) {
                return this.selected[0].description
            } else {
                return '-'
            }
        }
    },
    methods: {
        openDialog() {
            if (this.selected.length !== 1) {
                return
            }
            this.editDialog = true
        },
        edit() {
            this.editing = true
            const patchBody = {
                description: this.newObjectName
            }
            let apiURL
            if (this.objectType === this.nuvolosObjectTypes.FILE) {
                this.successMessage = 'File description changed successfully!'
                apiURL = this.objectType + 's/' + this.selected[0].fid
            } else if (this.objectType === this.nuvolosObjectTypes.TABLE) {
                this.successMessage = 'Table description changed successfully!'
                apiURL = this.objectType + 's/' + this.selected[0].tid
            } else if (this.objectType === this.nuvolosObjectTypes.COLUMN) {
                this.successMessage = 'Column description changed successfully!'
                apiURL = this.objectType + 's/' + this.selected[0].cid
            }
            this.$axios
                .patch(apiURL, patchBody)
                .then(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: this.successMessage,
                        snackBarTimeout: 5000,
                        snackBarIcon: 'check_circle'
                    })
                    this.dispatchFunction()
                })
                .catch(error => {
                    console.log(error)
                    const snackBarText = getBackendErrorMessage(error, `Failed to edit the ${this.objectType} description`)
                    if (snackBarText) {
                        this.$store.dispatch('showSnackBar', {
                            snackBarText,
                            snackBarTimeout: 10000,
                            snackBarIcon: 'error'
                        })
                    }
                })
                .finally(() => {
                    this.editDialog = false
                    this.editing = false
                })
        }
    },
    mounted() {
        if (this.oldName !== '-') {
            this.newObjectName = this.oldName
        }
    }
}
</script>
